import validators from '../../utils/validators';
import DrugPrescriptionAuthor from './prescription/author';
import DrugPrescriptionTime from './time';
import DrugPrescriptionMethod from './method';
import DrugPrescriptionDrug from './prescription/drug';
import {MS_IN_DAY} from '../../constants';

class DrugPrescription {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      patientId: (v) => validators.isNotEmptyString(v),
      quantity: (v) => validators.isNumber(v),
      archived: (v) => validators.isBoolean(v),
      bought: (v) => validators.isBoolean(v),
      comment: (v) => validators.isStringOrNull(v),
      note: (v) => validators.isStringOrNotSet(v),
      favorite: (v) => validators.isBoolean(v),
      finishDate: (v) => validators.isValidDate(v),
      startDate: (v) => validators.isValidDate(v),
      startedAt: (v) => validators.isValidDateOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugPrescription property '${property}' in ${data.id}`);
      }

      if (['finishDate', 'startDate'].includes(property)) {
        this[property] = new Date(data[property]);
      } else if (property === 'startedAt' && data[property] !== null) {
        this[property] = new Date(data[property]);
      } else {
        this[property] = data[property];
      }
    }

    try {
      this.author = new DrugPrescriptionAuthor(data.createdBy);
      this.drug = new DrugPrescriptionDrug(data.drug);
      this.methods = data.methods.map(i => new DrugPrescriptionMethod(i));
      this.times = data.times.map(i => new DrugPrescriptionTime(i));

      const timeDiff = this.finishDate.getTime() - this.startDate.getTime();

      this.duration = parseInt((timeDiff + MS_IN_DAY) / MS_IN_DAY);
    } catch (e) {
      throw new Error(`Error in DrugPrescription in ${data.id}: ${e.message}`);
    }
  }

  isFinished() {
    const diff = this.finishDate.getTime() - this.startDate.getTime();
    const end = this.startedAt instanceof Date
      ? this.startedAt.getTime() + diff + MS_IN_DAY
      : this.finishDate.getTime();

    return Date.now() > end && this.startedAt instanceof Date;
  }
}

export default DrugPrescription;
